import React from 'react';
export function AuditLog() {
  return <div data-id="element-2335">
      <div className="flex justify-between items-center mb-6" data-id="element-2336">
        <h1 className="text-2xl font-bold" data-id="element-2337">Audit Log</h1>
        <div data-id="element-2338">
          <input type="text" placeholder="Search logs..." className="border border-neutral-300 rounded p-2" data-id="element-2339" />
        </div>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-2340">
        <table className="min-w-full divide-y divide-neutral-200" data-id="element-2341">
          <thead className="bg-neutral-50" data-id="element-2342">
            <tr data-id="element-2343">
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2344">
                Date & Time
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2345">
                User
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2346">
                Action
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2347">
                Details
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2348">
                IP Address
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-neutral-200" data-id="element-2349">
            <tr data-id="element-2350">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2351">
                <div className="text-sm text-neutral-500" data-id="element-2352">
                  Jan 15, 2023 14:32:45
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2353">
                <div className="text-sm font-medium text-neutral-900" data-id="element-2354">
                  admin@example.com
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2355">
                <div className="text-sm text-neutral-500" data-id="element-2356">Created Client</div>
              </td>
              <td className="px-6 py-4" data-id="element-2357">
                <div className="text-sm text-neutral-500" data-id="element-2358">
                  Created new client: John Doe
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2359">
                <div className="text-sm text-neutral-500" data-id="element-2360">192.168.1.1</div>
              </td>
            </tr>
            <tr data-id="element-2361">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2362">
                <div className="text-sm text-neutral-500" data-id="element-2363">
                  Jan 15, 2023 10:15:22
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2364">
                <div className="text-sm font-medium text-neutral-900" data-id="element-2365">
                  broker@example.com
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2366">
                <div className="text-sm text-neutral-500" data-id="element-2367">Document Access</div>
              </td>
              <td className="px-6 py-4" data-id="element-2368">
                <div className="text-sm text-neutral-500" data-id="element-2369">
                  Viewed policy document: AUTO-12345
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2370">
                <div className="text-sm text-neutral-500" data-id="element-2371">192.168.1.2</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}